import gql from 'graphql-tag'

export const GET_PROGRESS_DATA = gql`
  query getProgressData($waveId: String, $accountIds: [String]) {
    coordinator(accountIds: $accountIds) {
      stats(waveId: $waveId) {
        learners {
          progress {
            path {
              goal {
                goalType
                nextMilestoneStepIndex
                minOnTrackStepIndex
                maxOnTrackStepIndex
                nextMilestoneDate
              }
              bySteps {
                nonStartersCount
                finishersCount
                steps {
                  levelIndex
                  stepIndex
                  value
                }
              }
            }
            medianStepsPerUser
            avgDaysPerStep
            pace {
              ahead
              onTrack
              behind
            }
            engagementByQuartile {
              q1 {
                daysPerStep
                inactiveUsersCount
              }
              q2 {
                daysPerStep
                inactiveUsersCount
              }
              q3 {
                daysPerStep
                inactiveUsersCount
              }
              q4 {
                daysPerStep
                inactiveUsersCount
              }
            }
          }
          total
        }
      }
    }
  }
`
export const GET_WAVES_LIST = gql`
  query getWavesList($labId: String, $accountIds: [String]) {
    coordinator(accountIds: $accountIds) {
      wave {
        list(filter: { labId: $labId }) {
          id
          name
          userIds
          startDate
          paceGoal {
            type
          }
        }
      }
    }
  }
`

export const GET_ENGAGEMENT_DATA = gql`
  query getEngagementData($waveId: String) {
    coordinator {
      stats(waveId: $waveId) {
        learners {
          progress {
            engagementByQuartile {
              q1 {
                daysPerStep
                inactiveUsersCount
              }
              q2 {
                daysPerStep
                inactiveUsersCount
              }
              q3 {
                daysPerStep
                inactiveUsersCount
              }
              q4 {
                daysPerStep
                inactiveUsersCount
              }
            }
          }
        }
      }
    }
  }
`
